import styles from './VersionList.module.scss'
import { Segmented } from 'antd';
import VersionTips from './VersionTips';

const VersionList = (props) => {
    const options = [{
        label: <p className={`${styles.SegmentedContent} ${styles.new}`}>相似风格  <VersionTips version={2} /></p>,
        value: 2
    }, {
        label: <p className={styles.SegmentedContent}>背景合成  <VersionTips version={1} /></p>,
        value: 1
    }, {
        label: <p className={styles.SegmentedContent}>拍同款  <VersionTips version={3} /></p>,
        value: 3
    },]

    return (
        <div className={styles.VersionList}>
            <Segmented
            block={true}
            options={options}
            value={props.version}
            onChange={(value) => {
                if(value == 1) {
                    props.onChange(1, 0.3)
                } else if (value == 2) {
                    props.onChange(2, 0.7)
                } else {
                    props.onChange(3, 0)
                }
            }}
        />
        </div>
    )
}
export default VersionList